import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SendToMobile = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18H7V6h10v1h2V1H5v22h14v-6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 12-4-4v3h-5v2h5v3z"
  }));
});
SendToMobile.displayName = 'SendToMobile';
export var SendToMobileDimensions = {
  height: 24,
  width: 24
};